import { Theme, alpha } from '@mui/material/styles'
import { SwitchProps } from '@mui/material/Switch'

import { onHover } from '../interaction'

// ----------------------------------------------------------------------

export default function Switch(theme: Theme) {
  const isLight = theme.palette.mode === 'light'

  const rootStyle = (ownerState: SwitchProps) => ({
    padding: '9px 13px 9px 12px',
    width: 58,
    height: 38,
    ...(ownerState.size === 'small' && {
      padding: '4px 8px 4px 7px',
      width: 40,
      height: 24,
    }),
    '& .MuiSwitch-thumb': {
      width: 14,
      height: 14,
      boxShadow: 'none',
      color: `${theme.palette.common.white} !important`,
      ...(ownerState.size === 'small' && {
        width: 10,
        height: 10,
      }),
    },
    '& .MuiSwitch-track': {
      opacity: 1,
      borderRadius: 14,
      backgroundColor: alpha(theme.palette.grey[500], 0.48),
    },
    '& .MuiSwitch-switchBase': {
      left: 3,
      padding: 12,
      // Same reason as Checkbox/Radio: MUI's default derives the thumb halo from the
      // colour prop; the hover is the kit's neutral wash, not a tint.
      ...onHover({ backgroundColor: theme.palette.action.hover }),
      ...(ownerState.size === 'small' && {
        padding: 7,
      }),
      '&.Mui-checked': {
        transform: 'translateX(13px)',
        // On is navy, the kit's selected colour; the palette color prop (amber) is ignored on purpose.
        color: theme.palette.background.paper,
        // The thumb has to read against the navy track, so it takes the surface colour rather than
        // a fixed white: in dark mode the navy track is a light blue, and a white thumb would
        // vanish into it, leaving no way to tell an on switch from an off one.
        '& .MuiSwitch-thumb': { color: `${theme.palette.background.paper} !important` },
        '&+.MuiSwitch-track': { opacity: 1, backgroundColor: theme.palette.primary.main },
        ...(ownerState.size === 'small' && {
          transform: 'translateX(9px)',
        }),
      },
      '&.Mui-disabled': {
        '& .MuiSwitch-thumb': { opacity: isLight ? 1 : 0.48 },
        // A disabled control must not wear the on-state: reset the track back to the
        // neutral grey, not just dim the navy the checked rule set above.
        '&+.MuiSwitch-track': { opacity: 0.48, backgroundColor: alpha(theme.palette.grey[500], 0.48) },
      },
    },
  })

  return {
    MuiSwitch: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: SwitchProps }) => rootStyle(ownerState),
      },
    },
  }
}
